module.exports = require("/var/www/wasif.dev.jt.hostingshouse.com/public_html/projects/gatsby/mumara/node_modules/react/index.js");